export default "__VITE_PUBLIC_ASSET__ab8d0839__"